import { Pipe, PipeTransform } from '@angular/core';
import { hasElements } from '../../utils/has-elements';

@Pipe({
  name: 'hasElements',
  standalone: false,
  pure: false
})
export class HasElementsPipe<T> implements PipeTransform {
  public transform(value: Array<T> | null | undefined): boolean {
    return hasElements(value);
  }
}
